import React, { useContext } from 'react'
import {Redirect} from 'react-router-dom';
import { EpicSpinner } from '../components';
import {AuthContext} from '../contexts/AuthContext';

const withAuth = (Component) => {
  const AuthRoute = () => {
    const {isAuthenticated, isLoading} = useContext(AuthContext)
    console.log('isAuthenticated, isLoading', isAuthenticated, isLoading)
    if (!!isAuthenticated) {
      return <Component />
    } else if (!!isLoading) {
      return <EpicSpinner />
    }
    return <Redirect to="/login" />
  }
  return AuthRoute
}

export default withAuth;